export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14878.db7a2bbc.jpg";